import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Call from "@ui-kit/icons/Call/Call.web";
import Speech from "@ui-kit/icons/Speech/Speech.web";
import Message from "@ui-kit/icons/Message/Message.web";
import Link from "@ui-kit/navigation/Link/Link.web";
import Divider from "@ui-kit/data-display/Divider/Divider.web";
import { Fragment } from "react";
import type { ContactsSharedProps } from "./Contacts.props";

export default function Contacts(props: ContactsProps): JSX.Element {
  const { widthDivider } = props;
  const { t } = useTranslation("checkout");

  const contacts = [
    {
      id: "tel",
      icon: (
        <Call.Outline
          color="primary.900"
          width="element.xl"
          height="element.xl"
        />
      ),
      href: "tel:18443077469",
      description: "+1 844-307-7469",
      isExternal: false,
    },
    {
      id: "chat",
      icon: (
        <Speech.Outline
          color="primary.900"
          width="element.xl"
          height="element.xl"
        />
      ),
      href: "https://help.showpass.com/hc/en-us/categories/360001836433-For-Ticket-Buyers",
      description: t("Chat with us"),
      isExternal: true,
    },
    {
      id: "email",
      icon: (
        <Message.Outline
          colorPalette="primary"
          width="element.xl"
          height="element.xl"
        />
      ),
      href: "https://help.showpass.com/hc/en-us/requests/new",
      description: t("Email us"),
      isExternal: true,
    },
  ];

  return (
    <Flex direction="column" gap="md" data-testid="contacts">
      <Text fontSize="lg" fontWeight={700}>
        {t("Help with your order")}
      </Text>
      {contacts.map((item, index) => (
        <Fragment key={item.id}>
          <Flex gap="xs" height="element.xl">
            {item.icon}
            <Link
              fontSize="sm"
              fontWeight="600"
              color="font.dark"
              p="none"
              href={item.href}
              data-testid={`contact-${item.id}`}
              isExternal={item.isExternal}
            >
              {item.description}
            </Link>
          </Flex>
          {widthDivider && index !== contacts.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Flex>
  );
}

export type ContactsProps = ContactsSharedProps & {
  // Add any web specific props here.
};
